module.exports = __webpack_public_path__ + "img/성수카페.b759c7b9.png";